// Colored pill per JobStatusT. Color choices match the architect's spec:
// queued=gray, running=blue (spinner), succeeded=green, failed=red,
// canceled=slate, timeout=amber.

import { Badge } from '@/components/ui/badge';
import type { DiscoveryStatus } from '@/lib/discoveries';
import { Check, Clock, Loader2, Square, X } from 'lucide-react';

const STYLES: Record<DiscoveryStatus, string> = {
  queued: 'bg-zinc-200 text-zinc-800 hover:bg-zinc-200 dark:bg-zinc-700 dark:text-zinc-100',
  running: 'bg-blue-100 text-blue-900 hover:bg-blue-100 dark:bg-blue-900/40 dark:text-blue-100',
  succeeded:
    'bg-emerald-100 text-emerald-900 hover:bg-emerald-100 dark:bg-emerald-900/40 dark:text-emerald-100',
  failed: 'bg-red-100 text-red-900 hover:bg-red-100 dark:bg-red-900/40 dark:text-red-100',
  canceled: 'bg-slate-200 text-slate-700 hover:bg-slate-200 dark:bg-slate-700 dark:text-slate-100',
  timeout:
    'bg-amber-100 text-amber-900 hover:bg-amber-100 dark:bg-amber-900/40 dark:text-amber-100',
};

const LABELS: Record<DiscoveryStatus, string> = {
  queued: 'Queued',
  running: 'Running',
  succeeded: 'Succeeded',
  failed: 'Failed',
  canceled: 'Canceled',
  timeout: 'Timed out',
};

function Icon({ status }: { status: DiscoveryStatus }) {
  switch (status) {
    case 'running':
      return <Loader2 className="mr-1 h-3 w-3 animate-spin" />;
    case 'succeeded':
      return <Check className="mr-1 h-3 w-3" />;
    case 'failed':
      return <X className="mr-1 h-3 w-3" />;
    case 'canceled':
      return <Square className="mr-1 h-3 w-3" />;
    case 'timeout':
      return <Clock className="mr-1 h-3 w-3" />;
    default:
      return <Clock className="mr-1 h-3 w-3" />;
  }
}

export function DiscoveryStatusBadge({ status }: { status: DiscoveryStatus }) {
  return (
    <Badge variant="outline" className={`border-transparent ${STYLES[status]}`}>
      <Icon status={status} />
      {LABELS[status]}
    </Badge>
  );
}
